export const categoryColumnsConfig = {
  id:"id",
  NAME: "Name",
  STATUS: "Status",
  ACTIONS: "Actions", // ✅ Added label for action column
  messages: "Are you sure you want to delete this category?" // Optional: for ConfirmPopup
};
